(() => {
  const data = document.getElementById('gmm-purchase-prices');
  if (!data || data.dataset.initialized) return;
  data.dataset.initialized = 'true';
  const section = data.closest('.shopify-section');
  if (!section) return;
  const variants = JSON.parse(data.textContent);
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  });
  const setText = (element, value) => {
    if (element && element.textContent !== value) element.textContent = value;
  };
  let scheduled = false;
  function update() {
    scheduled = false;
    const widget = section.querySelector('.stayai-subscriptions');
    const form = section.querySelector('product-form-component form');
    if (!widget || !form) return;
    const subscribed = widget.querySelector('input[name="purchaseType"]:checked')?.value === 'purchaseTypeSubscription';
    const variant = variants.find(v => String(v.id) === form.elements.id?.value);
    const planId = form.elements.selling_plan?.value;
    const allocation = variant?.selling_plan_allocations?.find(a => String(a.selling_plan_id) === planId);
    const priceSource = widget.querySelector(subscribed ? '[data-stayai-subscription-price]' : '[data-stayai-onetime-price]');
    const stickyPrice = section.querySelector('.sticky-add-to-cart__price');
    // Mirror the widget's current formatted price, including its compare-at price.
    if (priceSource && stickyPrice && stickyPrice.innerHTML !== priceSource.innerHTML) {
      stickyPrice.innerHTML = priceSource.innerHTML;
    }
    const mainButton = form.querySelector('[ref="addToCartButton"]');
    const stickyButton = section.querySelector('sticky-add-to-cart [ref="addToCartButton"]');
    const label = subscribed ? 'Subscribe' : 'Add to cart';
    for (const button of [mainButton, stickyButton]) {
      if (!button) continue;
      const unavailable = !variant?.available;
      if (button === stickyButton && mainButton && button.disabled !== mainButton.disabled) button.disabled = mainButton.disabled;
      if (!unavailable) {
        const content = button.querySelector('.add-to-cart-text__content > span');
        setText(content, label);
        const price = priceSource?.cloneNode(true);
        price?.querySelectorAll('s').forEach(el => el.remove());
        const accessible = `${label}${price ? ' — ' + price.textContent.trim() : ''}`;
        if (button.getAttribute('aria-label') !== accessible) button.setAttribute('aria-label', accessible);
      }
    }
    const amount = subscribed ? allocation?.per_delivery_price : variant?.price;
    const perServing = section.querySelector('#pw-per-serving-text');
    const comparison = section.querySelector('#pw-per-serving-compare');
    if (Number.isFinite(amount)) {
      setText(perServing, `14 sticks · ${money.format(amount / 1400)}/stick`);
      setText(comparison, subscribed ? ` — you save ${money.format((variant.price - amount) / 1400)}/stick with Subscribe & Save` : ' — less than a glass of wine');
    }
    let terms = section.querySelector('[data-gmm-purchase-terms]');
    if (!terms) {
      terms = document.createElement('p');
      terms.dataset.gmmPurchaseTerms = '';
      terms.setAttribute('aria-live', 'polite');
      terms.style.cssText = 'font-size:12px;text-align:center;margin:8px 0;';
      form.after(terms);
    }
    const frequency = widget.querySelector('select[name="stayai_selling_plan"] option:checked')?.textContent;
    setText(terms, subscribed && allocation ? `${frequency || 'Recurring'} delivery. Renews automatically. Skip, pause or cancel anytime.` : '');
    terms.hidden = !subscribed || !allocation;
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }
  section.addEventListener('change', schedule);
  section.addEventListener('input', schedule);
  // Stay Ai mounts asynchronously and replaces widget nodes when the choice changes.
  const observer = new MutationObserver(schedule);
  observer.observe(section, { childList: true, subtree: true, characterData: true,
    attributes: true, attributeFilter: ['value', 'checked', 'disabled', 'class'] });
  schedule();
})();
